import { createSlice } from '@reduxjs/toolkit';
import { INIT_STATUS, IDLE_STATUS, LOADING_STATUS } from '../../../../../constants';
import { fetchOffersAsync } from './thunk';

const initialState = {
  status: INIT_STATUS,
  offers: [],
};

export const availableOffers = createSlice({
  name: 'available-offers',
  initialState,
  extraReducers: (builder) => {
    // builder for fetchOffersAsync
    builder
      .addCase(fetchOffersAsync.pending, (state) => {
        state.status = LOADING_STATUS;
      })
      .addCase(fetchOffersAsync.fulfilled, (state, { payload }) => {
        state.status = IDLE_STATUS;
        if (payload?.success && payload.result) {
          state.offers = payload.result.listings || [];
        }
      });
  },
});

export { fetchOffersAsync };

export default availableOffers.reducer;